function convertHeadersThatAreSortable(headers, sortableList) {
  if (!sortableList?.length) return Object.values(headers);
  return Object.values(headers).map((h) => (sortableList.includes(h.key) ? { ...h, withSort: true } : h));
}

export default convertHeadersThatAreSortable;
